// Response for /api/frontend/get-search-results-header
const searchResultsHeader = {
    tripName: "FRLGF-128210459",
    legs: [
        {
            departureAirport: {
                longName: "London Biggin Hill, London",
                shortName: "EGKB",
            },
            arrivalAirport: {
                longName: "Copenhagen Kastrup, Copenhagen",
                shortName: "EKCH",
            },
            departureTime: "23/12/2026 13:00",
            arrivalTime: "?",
            luggage: 1,
            passengers: 2,
        },
    ],
    expired: false,
    agentName: "Freddie Maidens",
    agentPhone: "+44 7769 668195",
    agentEmail: "freddie@shyaviation.com",
    companyName: null,
    quotesreleaseDate: "2026-09-16T15:00:35.103",
    showMovida: true,
};

export default searchResultsHeader;
